import { Component, Output, EventEmitter, ContentChildren, QueryList, AfterContentInit, Input, } from '@angular/core';
import { TabComponent } from '../tab/tab.component';

@Component({
  selector: 'pds-tab-group',
  templateUrl: './tab-group.component.html',
  styleUrls: ['./tab-group.component.scss']
})
export class TabGroupComponent implements AfterContentInit {

  @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;
  @Output() selectedIndexChange: EventEmitter<any> = new EventEmitter<any>();
  // tslint:disable-next-line: no-input-rename
  @Input('align-tabs') alignTabs: string;
  @Input() selectedIndex: number;

  constructor() { }

  ngOnChanges() {
    if (this.tabs) {
      this.changeTab(this.selectedIndex);
    }
  }

  ngAfterContentInit() {
    const activeTabs = this.tabs.filter((tab) => tab.active);
    if (activeTabs.length === 0) {
      this.selectTab(this.tabs.first, 0);
    }
  }

  changeTab(selectedIndex){
    const selected = this.tabs.find((_, index) => index === selectedIndex);
    this.selectTab(selected, selectedIndex);
  }

  selectTab(tab, index){
    this.tabs.toArray().forEach((tab) => tab.active = false);

    tab.active = true;

    this.selectedIndexChange.emit(index);
  }
}
